import { Store } from '@ngxs/store';
import { switchMap } from 'rxjs/operators';
import { CourseStateFacade } from './course-state.facade';
import { CourseState } from './course.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "./course-state.facade";
export let CoursesResolver = /*#__PURE__*/(() => {
  class CoursesResolver {
    constructor(store, facade) {
      this.store = store;
      this.facade = facade;
    }
    resolve(route) {
      // wait for async loadCourses to complete, then select courses from store once
      return this.facade.initialize(true).pipe(switchMap(() => this.store.selectOnce(CourseState.courses)));
    }
    static {
      this.ɵfac = function CoursesResolver_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoursesResolver)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.CourseStateFacade));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CoursesResolver,
        factory: CoursesResolver.ɵfac
      });
    }
  }
  return CoursesResolver;
})();